// extracted by mini-css-extract-plugin
export default {"container":"ContactDialog_container__ouVtz"};